{
  "common.close": "關閉",
  "common.athleteFallback": "運動員 {id}",
  "splash.title": "{app} — 動態活動視覺化",
  "splash.tagline": "把你的 Strava&nbsp;資料變成動態地圖",
  "splash.demo": "示範",
  "tab.query.title": "{name} 的地圖",
  "tab.query.heading": "活動查詢:",
  "tab.query.optDays": "最近天數",
  "tab.query.optActivities": "最近活動數",
  "tab.query.optIds": "活動 ID",
  "tab.query.optDates": "日期範圍",
  "tab.query.idsPlaceholder": "在此輸入活動 ID",
  "tab.query.after": "起始:",
  "tab.query.before": "結束:",
  "tab.query.autozoom": "匯入後自動縮放到查詢範圍 <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> 查詢",
  "tab.query.createAccount": "請建立帳號或登入。",
  "tab.query.sports": "運動：",
  "tab.query.allSports": "所有運動",
  "tab.query.sportsExcept": "全部，除了",
  "tab.query.sportsNone": "無",
  "tab.query.loadingSports": "正在載入運動…",
  "tab.query.sportsFailed": "無法載入此地圖的運動",
  "tab.query.noSports": "尚無活動",
  "tab.activities.title": "已顯示的活動",
  "tab.activities.clearSelection": "清除選取",
  "tab.activities.renderSelected": "顯示所選",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> 縮放到所選範圍",
  "tab.controls.title": "圖層設定",
  "tab.controls.timescale": "時間尺度 <i>&tau;</i>",
  "tab.controls.timescaleHint": "播放速度",
  "tab.controls.period": "週期 <i>T</i>",
  "tab.controls.periodHint": "實際時間 ~ 模型時間",
  "tab.controls.dotSize": "圓點大小",
  "tab.controls.pathWidth": "軌跡寬度",
  "tab.controls.pathWidthHint": "設為 0 可隱藏軌跡",
  "tab.controls.colors": "配色",
  "tab.controls.colorsHint": "旋轉調色盤",
  "tab.controls.shadows": "陰影",
  "tab.profile.loginTitle": "登入",
  "tab.profile.anonNote": "使用 Strava 登入即可檢視自己的活動，並管理你的 Heatflask 帳號。",
  "tab.profile.loginLink": "使用 Strava 登入",
  "tab.profile.editOnStrava": "在 Strava 上編輯個人資料",
  "tab.profile.indexNote": "我們會為你的活動摘要建立索引，以便快速存取。",
  "tab.profile.viewIndex": "檢視索引",
  "tab.profile.sharedMaps": "共享地圖",
  "tab.profile.sharedMapsNote": "關閉：只有你能在 Heatflask 中看到自己的活動。開啟：任何拿到你地圖連結的人都能看到你在 Strava 上公開的活動。私密活動始終只有你能看到。 <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">隱私如何運作</a>",
  "tab.profile.logout": "登出",
  "tab.profile.deleteAccount": "刪除帳號",
  "tab.profile.deleteConfirm": "要刪除你的 Heatflask 帳號嗎?\n\n這會移除已建立索引的活動，並撤銷 Heatflask 對你 Strava 資料的存取權限。此操作無法復原。",
  "tab.profile.languageHeading": "語言",
  "tab.profile.languageAuto": "自動",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">歡迎幫我們修正或新增翻譯！</a>",
  "tab.profile.unitsHeading": "單位",
  "tab.profile.unitsAuto": "自動",
  "tab.profile.unitsMetric": "公制 (km, m)",
  "tab.profile.unitsImperial": "英制 (mi, ft)",
  "tab.profile.textSizeHeading": "文字大小",
  "tab.profile.textSmaller": "更小",
  "tab.profile.textReset": "標準",
  "tab.profile.textLarger": "更大",
  "tab.profile.mapDefaultsHeading": "地圖預設設定",
  "tab.profile.mapDefaultsNote": "開啟連結未指定樣式的地圖時，使用此底圖、地形和圖層設定。你分享的連結仍會完全顯示你所看到的內容。",
  "tab.profile.mapDefaultsSave": "儲存為我的預設設定",
  "tab.profile.mapDefaultsForget": "清除",
  "tab.info.title": "資訊",
  "tab.info.controlsHeading": "操作",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + 拖曳",
  "tab.info.shiftDragDesc": "框選活動。在觸控螢幕上，先輕觸 <i class=\"hf-object-group\"></i>，再用單指拖曳。最後選取的活動會顯示詳細資訊，活動清單也會捲動到該項。",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + 拖曳",
  "tab.info.ctrlDragDesc": "以 3D 方式旋轉並傾斜地圖，也可用雙指操作",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "開啟或關閉側邊欄",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "上一個或下一個側邊欄分頁",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "關閉側邊欄",
  "tab.info.liveUrlHeading": "即時網址",
  "tab.info.liveUrlDesc": "地圖視角與動畫設定都保存在頁面網址中，因此你分享給誰，對方看到的就是同一個畫面。",
  "tab.info.videoHeading": "匯出影片",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> 按鈕可將動畫錄製成 MP4：輕觸它，把方框調整到你想要的地圖範圍，再輕觸一次即可錄製。錄製的是完整的一個動畫週期，因此影片可以無縫循環；若一個週期超過 {max} 秒（Strava 允許的最長影片），則會在 {max} 秒處截斷。",
  "tab.info.contributeHeading": "參與貢獻",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> 在 GitHub 上贊助",
  "tab.info.contactsHeading": "聯絡方式",
  "map.basemapAndTerrain": "底圖與地形",
  "map.pauseAnimation": "暫停動畫",
  "map.resumeAnimation": "繼續動畫",
  "capture.record": "錄製影片（一個週期 {period} 秒）",
  "capture.recordTruncated": "錄製影片（一個週期 {period} 秒；只錄製前 {max} 秒）",
  "capture.recordArea": "錄製方框內的區域",
  "capture.stop": "停止錄製",
  "capture.selectionTooSmall": "所選範圍太小",
  "capture.saved": "已儲存 {name}（{size}）",
  "capture.cancelled": "已取消錄製",
  "capture.failed": "錄製失敗: {error}",
  "capture.loadingEncoder": "正在載入編碼器…",
  "capture.waitingForMap": "正在等待地圖載入…",
  "capture.encoding": "正在編碼… {percent}%",
  "capture.finalizing": "正在完成…",
  "share.title": "分享此地圖的連結",
  "share.copied": "連結已複製",
  "share.copiedUnshared": "連結已複製，但你的地圖未共享，其他人無法開啟。開啟「共享地圖」即可變更。",
  "share.unshared": "你的地圖未共享，其他人無法開啟此連結。開啟「共享地圖」即可變更。",
  "share.copyThis": "複製此連結：",
  "update.available": "Heatflask 有新版本可用。",
  "update.reload": "重新載入",
  "import.title": "正在匯入",
  "import.stop": "停止",
  "import.stopping": "正在停止…",
  "import.contacting": "正在連線 Strava…",
  "import.countOf": "{total} 筆中的 {received} 筆",
  "import.count": "{received} 筆活動",
  "import.waitStrava": "因 Strava 下載限制暫停至 {time}。請保持此頁面開啟；重新整理不會更快。",
  "import.waitRationed": "今天的快速下載額度已用完。其餘部分將於 {time} 較慢地繼續。請保持此頁面開啟。",
  "import.dailyLimit": "Strava 每日下載上限已用完。請在 {time} 之後再試。",
  "import.dailyRationed": "你今天的 Strava 下載份額已用完。請在 {time} 之後再試。",
  "import.noActivitiesYet": "你的 Strava 帳戶還沒有任何活動。在 Strava 上記錄或上傳一項活動後，它就會顯示在這裡。",
  "table.noActivities": "沒有活動",
  "table.untitled": "(無標題)",
  "activities.pageTitle": "{app} — 活動索引",
  "activities.heading": "活動索引",
  "activities.fetching": "正在取得活動...",
  "activities.rateLimit": "已達到 Strava 的速率限制；將於 {time} 繼續",
  "activities.noData": "抱歉，沒有資料 &#128577;",
  "activities.colServerCache": "軌跡已快取在伺服器（Mongo）",
  "activities.colBrowserCache": "軌跡已快取在此瀏覽器",
  "activities.cachedServer": "{id} 的軌跡已快取在伺服器",
  "activities.notCachedServer": "{id} 的軌跡未快取在伺服器",
  "activities.cachedBrowser": "{id} 的軌跡已快取在此瀏覽器",
  "activities.notCachedBrowser": "{id} 的軌跡未快取在此瀏覽器",
  "sport.AlpineSki": "高山滑雪",
  "sport.BackcountrySki": "野雪滑雪",
  "sport.Badminton": "羽球",
  "sport.Basketball": "籃球",
  "sport.Canoeing": "划獨木舟",
  "sport.Cricket": "板球",
  "sport.Crossfit": "CrossFit",
  "sport.Dance": "舞蹈",
  "sport.EBikeRide": "電動自行車騎乘",
  "sport.Elliptical": "滑步機",
  "sport.EMountainBikeRide": "電動登山車騎乘",
  "sport.Golf": "高爾夫",
  "sport.GravelRide": "礫石路騎乘",
  "sport.Handcycle": "手搖車",
  "sport.HighIntensityIntervalTraining": "高強度間歇訓練",
  "sport.Hike": "健行",
  "sport.IceSkate": "溜冰",
  "sport.InlineSkate": "直排輪",
  "sport.Kayaking": "獨木舟",
  "sport.Kitesurf": "風箏衝浪",
  "sport.MountainBikeRide": "登山車騎乘",
  "sport.NordicSki": "越野滑雪",
  "sport.Padel": "板式網球",
  "sport.PhysicalTherapy": "物理治療",
  "sport.Pickleball": "匹克球",
  "sport.Pilates": "皮拉提斯",
  "sport.Racquetball": "美式壁球",
  "sport.Ride": "騎乘",
  "sport.RockClimbing": "攀岩",
  "sport.RollerSki": "滑輪滑雪",
  "sport.Rowing": "划船",
  "sport.Run": "跑步",
  "sport.Sail": "帆船",
  "sport.Skateboard": "滑板",
  "sport.Snowboard": "單板滑雪",
  "sport.Snowshoe": "雪鞋健行",
  "sport.Soccer": "足球",
  "sport.Squash": "壁球",
  "sport.StairStepper": "踏步機",
  "sport.StandUpPaddling": "立槳",
  "sport.Surfing": "衝浪",
  "sport.Swim": "游泳",
  "sport.TableTennis": "桌球",
  "sport.Tennis": "網球",
  "sport.TrailRun": "越野跑",
  "sport.Velomobile": "人力車",
  "sport.VirtualRide": "虛擬騎乘",
  "sport.VirtualRow": "虛擬划船",
  "sport.VirtualRun": "虛擬跑步",
  "sport.Volleyball": "排球",
  "sport.Walk": "步行",
  "sport.WeightTraining": "重量訓練",
  "sport.Wheelchair": "輪椅",
  "sport.Windsurf": "風浪板",
  "sport.Workout": "訓練",
  "sport.Yoga": "瑜伽"
}
